/* Represents the data summarized for unsegmented, or the sum of selected child segments */
interface SumTreeSummaryValues {
  value: number;
  secondaryValue?: number;
  timeComparisonValue: number;
  secondaryTimeComparisonValue?: number;
  liftComparisonValue?: number;
  baselineComparisonValue?: number;
}

interface SumTreeSegment {
  label: string;
  /* In a root segment, this represents the unsegmented value from Arb. Otherwise it is a leaf value */
  value: number;
  /* In a root segment, this represents the unsegmented value from Arb. Otherwise it is a leaf value */
  secondaryValue?: number;
  /* In a root segment, this represents the unsegmented value from Arb. Otherwise it is a leaf value */
  timeComparisonValue: number;
  /* In a root segment, this represents the unsegmented value from Arb. Otherwise it is a leaf value */
  secondaryTimeComparisonValue?: number;
  /* Only ever present in a leaf value */
  liftComparisonValue?: number;
  baselineComparisonUnit?: string;
  /* Should only ever be present in a leaf value */
  baselineComparisonValue?: number;
  headerType: HeaderType;
  path: string[];
}

/**
 * SumTree where children at each depth are a nested object. Necessary for quick segment lookups by path
 * such as accessing time comparison segments or tooltip stats.
 */
export interface UnorderedSumTree {
  [label: string]: UnorderedSumTreeNode;
}

export interface UnorderedSumTreeNode extends SumTreeSegment {
  children?: UnorderedSumTree;
  unsegmented?: SumTreeSummaryValues;
  // TODO(tn) unused, remove
  sumOfChildren?: SumTreeSummaryValues;
}

/**
 * SumTree where children at each depth are an array. Necessary for manipulating and displaying ordered data
 * where there could be children with duplicate segments e.g. when sorting by value.
 */
export interface OrderedSumTree extends SumTreeSegment {
  children?: OrderedSumTree[];
  unsegmented?: SumTreeSummaryValues;
  // TODO(tn) unused, remove
  sumOfChildren?: SumTreeSummaryValues;
}

export enum HeaderType {
  DATE_ISO = `date_iso`,
  DATE_TYPECAST_STRING = `date_typecast_string`,
  DATE_HOURLY = `date_hourly`,
  DATE_DAILY = `date_daily`,
  DATE_WEEKLY = `date_weekly`,
  DATE_MONTHLY = `date_monthly`,
  DATE_QUARTERLY = `date_quarterly`,
  DATE_DAY_OF_WEEK = `date_day_of_week`,
  NUMBER = `number`,
  NUMBER_RANGE = `number_range`,
  STRING = `string`,
}
